import { PropertyListingTiles } from "../../../PropertyListingTiles";
import { SectionHeader } from "../../../SectionHeader";

import { useHasPropertyListingsQuery } from "./HasPropertyListings.query";
import * as styles from "./PropertyListings.styles";

interface Props {
  listingAgentKey: string;
}

const PropertyListings = ({ listingAgentKey }: Props) => {
  const { data, loading } = useHasPropertyListingsQuery({
    variables: {
      filter: {
        listingAgentKeys: [listingAgentKey],
      },
    },
  });

  if (loading || (data?.propertyListings?.length || 0) <= 0) return null;

  return (
    <div css={styles.listingsContainer} className="container">
      <SectionHeader text="My Listings" />
      <PropertyListingTiles listingAgentKeys={[listingAgentKey]} />
    </div>
  );
};

export { PropertyListings };
